<template>
	<NuxtLink
		:to="url"
		:class="classes"
	>
		<h4
			class="category-heading"
			v-html="name"
		/>
	</NuxtLink>
</template>

<script setup lang="ts">
const props = defineProps<{ url: string; name: string; class?: string }>();

const classes = computed(() => `${props.class}`);
</script>

<style lang="scss" scoped>
@import "@assets/utils.scss";
.category-heading {
	color: $primary-500;
	font-weight: 600;
	text-transform: uppercase;
	font-size: 18px;
	line-height: 1;
	display: inline-block;
}
</style>
